module.exports = __webpack_public_path__ + "static/media/infoIconYellow.9c4120f1.svg";